import { Line, NewReaction } from '@/types/models';
import { ReactionLineTarget } from '@/redux/reactions/reactions.types';

/** One of the lines a reaction owns, paired with the endpoint that persists it. */
export type ReactionLine = {
  target: ReactionLineTarget;
  line: Line;
};

/**
 * Collects every line a reaction owns: the reaction line itself, then one line
 * per reactant, product, modifier and operator. The reaction line comes first
 * because its styling seeds the shared line form.
 */
export const getReactionLines = (reaction: NewReaction): Array<ReactionLine> => [
  { target: { kind: 'reaction' }, line: reaction.line },
  ...reaction.reactants.map(reactant => ({
    target: { kind: 'reactant' as const, id: reactant.id },
    line: reactant.line,
  })),
  ...reaction.products.map(product => ({
    target: { kind: 'product' as const, id: product.id },
    line: product.line,
  })),
  ...reaction.modifiers.map(modifier => ({
    target: { kind: 'modifier' as const, id: modifier.id },
    line: modifier.line,
  })),
  ...reaction.operators.map(operator => ({
    target: { kind: 'operator' as const, id: operator.id },
    line: operator.line,
  })),
];
